import { Type } from "@sinclair/typebox";
import { MessengerSettings } from "./settings";
import { Route } from "./routes";
export const MessengerConfig = Type.Object({
    mode: Type.Union([Type.Literal("normal"), Type.Literal("messenger-only")]),
    settings: MessengerSettings,
    routes: Type.Optional(Type.Array(Route)),
    revId: Type.Optional(Type.String()),
}, {
    title: "MessengerConfig",
});
export const MessengerPublicConfigSchema = Type.Object({
    mode: Type.Union([Type.Literal("normal"), Type.Literal("messenger-only")]),
    // EXCLUDE deployment settings from public config
    settings: Type.Omit(MessengerSettings, ["deploymentSettings"]),
    routes: Type.Optional(Type.Array(Route)),
    revId: Type.Optional(Type.String()),
}, {
    title: "MessengerPublicConfig",
});
export const UrlCacheableConfigSchema = Type.Optional(Type.Object({
    platform: Type.Optional(Type.Union([Type.Literal("WEB"), Type.Literal("IOS"), Type.Literal("ANDROID")])),
    /**
     * Messenger token used to verify the parent is either an admin preview or HelpCenter.
     * In the case of admin preview, the token allows us to return a draft config.
     * In the case of HelpCenter, the token allows us to confirm messenger is succesfully installed on their HC.
     */
    messengerToken: Type.Optional(Type.String()),
}));
export const WorkflowInteractionSchema = Type.Object({
    id: Type.String(),
    // loosely define key, so we don't fail validation on future keys
    // added to workflow engine without getting updated here
    key: Type.String(),
    file: Type.Optional(Type.Object({
        uuid: Type.String(),
    })),
});
export const WorkflowRevisionNodesSchema = Type.Array(Type.Object({
    id: Type.String(),
    data: Type.Object({
        interactions: Type.Array(WorkflowInteractionSchema),
    }),
}));
